import { buildUserNotification } from 'hooks/useUserNotification';
import type { Dispatch } from 'redux';
import type { Msg } from 'state/notifications/notification.model';

export interface ToastUtils {
  success(message: Msg, title: Msg, autoClose?: boolean): void;
  info(message: Msg, title: Msg, autoClose?: boolean): void;
  warn(message: Msg, title: Msg, autoClose?: boolean): void;
  error(message: Msg, title: Msg, autoClose?: boolean): void;
}

export const getToastUtils = (dispatch: Dispatch<any>): ToastUtils => {
  const notification = buildUserNotification(dispatch);

  const success = (message: Msg, title: Msg, autoClose: boolean = true) => {
    return notification.success({ title, content: [message], closeAutomatically: autoClose });
  };
  const info = (message: Msg, title: Msg, autoClose: boolean = true) => {
    return notification.info({ title, content: [message], closeAutomatically: autoClose });
  };
  const warn = (message: Msg, title: Msg, autoClose: boolean = true) => {
    return notification.warn({ title, content: [message], closeAutomatically: autoClose });
  };
  const error = (message: Msg, title: Msg, autoClose: boolean = true) => {
    return notification.error({ title, content: [message], closeAutomatically: autoClose });
  };

  return {
    success,
    info,
    warn,
    error,
  };
};
